import React from 'react';
import '../styles/sitemap.css';
import { Link } from 'react-router-dom';

function Sitemap() {
  return (
    <div className="sitemap-container">
      <h1 className="sitemap-title">Sitemap</h1>
      <ul className="sitemap-list">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/contact">Contact</Link></li>
        <li><Link to="/domains">Domains</Link></li>
        <li><Link to="/cpanel">cPanel</Link></li>
        <li><Link to="/wordpress">WordPress</Link></li>
        <li><Link to="/trust">Trust</Link></li>
        <li><Link to="/privacy">Privacy Policy</Link></li>
        <li><Link to="/terms">Terms and Conditions</Link></li>
        <li><Link to="/do-not-sell">Do Not Sell My Info</Link></li>
      </ul>
    </div>
  );
}

export default Sitemap;
